import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { useRenderStore } from "../../stores/renderStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnComponent',
  props: ["component"],
  setup(__props) {

const renderStore = useRenderStore();

const props = __props;

const columnWidthClass = (width: number) => {
    switch (width) {
        case 3:
            return "rd-w-full md:rd-w-1/4";
        case 4:
            return "rd-w-full md:rd-w-1/3";
        case 6:
            return "rd-w-full md:rd-w-1/2";
        case 8:
            return "rd-w-full md:rd-w-2/3";
        case 9:
            return "rd-w-full md:rd-w-3/4";
        case 12:
            return "rd-w-full md:rd-w-full";
        default:
            return "rd-w-full";
    }
}

const getColumnWidthClass = computed(() =>
    columnWidthClass(props.component.customData.columnWidth)
);

const horizontalAlignmentClass = computed(() => {
    switch (props.component.customData.horizontalAlignment) {
        case 'start':
            return 'rd-items-start';
        case 'center':
            return 'rd-items-center';
        case 'end':
            return 'rd-items-end';
        default:
            return '';
    }
});

const verticalAlignmentClass = computed(() =>
    props.component.customData.verticalAlignment
        ? `rd-justify-${props.component.customData.verticalAlignment}`
        : ""
);

const columnDisplay = computed(() => (props.component.customData.verticalAlignment ? "rd-flex" : ""));

const flexColumn = computed(() => (props.component.components.length > 1 ? "rd-flex-col" : ""));

const fullWidthImage = computed(() => ((props.component.components.length === 1 && props.component.components[0].type == 'image-component'
    && props.component.components[0].styles.fullWidth) && 'rd-px-0'));

return (_ctx: any,_cache: any) => {
  return (_unref(renderStore).hasOneSectionAndIsModalEmbed)
    ? _renderSlot(_ctx.$slots, "children", { key: 0 })
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["layout-col rd-relative", [
            __props.component.styles.cssClass,
            getColumnWidthClass.value,
            horizontalAlignmentClass.value,
            verticalAlignmentClass.value,
            columnDisplay.value,
            flexColumn.value,
            fullWidthImage.value]])
      }, [
        _renderSlot(_ctx.$slots, "controls"),
        _renderSlot(_ctx.$slots, "children")
      ], 2))
}
}

})